const projectJson = window.__project_json_;
const envType = window.__env_type_;
const weblog = window.weblog;
const getRequestAgent = window.getRequestAgent;
const { serviceAgent, ENV, callConnector: oldCallConnector, call } = window.designerService;
const requestAgent = getRequestAgent();

export function callService(id: number, params: any) {
  return serviceAgent(id, params, {
    context: { projectData: projectJson },
    publishEnv: envType,
    useProxyAfterPublish: envType !== ENV.PROD,
    prefix: '/app/eca/desn/proxy',
    agent: requestAgent,
  });
}

export function callConnector(connector: any, params: any) {
  if (connector.type === 'http') {
    return call(connector, params, {
      context: { projectData: projectJson },
      publishEnv: envType,
      useProxyAfterPublish: envType !== ENV.PROD,
      prefix: '/app/eca/desn/proxy',
      agent: requestAgent,
    });
  }
  return oldCallConnector(connector, params, {
    context: { projectData: projectJson },
    publishEnv: envType,
    useProxyAfterPublish: envType !== ENV.PROD,
    prefix: '/app/eca/desn/proxy',
    agent: requestAgent,
  });
}

export function getUrlParams() {
  // 如果未提供url，则使用当前页面的URL
  const currentUrl = window.location.href;
  // 创建一个空对象存储参数
  const params = {};
  // 分离URL中的查询字符串部分（?后面的部分）
  const queryString = currentUrl.split('?')[1];
  // 如果没有查询字符串，直接返回空对象
  if (!queryString) {
    return params;
  }
  // 处理哈希(#)后面的部分，不纳入参数解析
  const hashIndex = queryString.indexOf('#');
  const processedQuery = hashIndex !== -1
    ? queryString.substring(0, hashIndex)
    : queryString;
  // 分割参数对
  const paramPairs = processedQuery.split('&');
  // 遍历参数对并解析
  paramPairs.forEach(pair => {
    // 分割键和值
    const [key, value] = pair.split('=');

    // 处理没有值的参数（如?flag）
    if (key) {
      // 解码参数（处理特殊字符和空格）
      const decodedKey = decodeURIComponent(key);
      const decodedValue = value !== undefined ? decodeURIComponent(value) : '';

      // 如果参数名已存在，转为数组
      if (params.hasOwnProperty(decodedKey)) {
        if (!Array.isArray(params[decodedKey])) {
          params[decodedKey] = [params[decodedKey]];
        }
        params[decodedKey].push(decodedValue);
      } else {
        params[decodedKey] = decodedValue;
      }
    }
  });
  return params;
}

export function ajax(
  url: string,
  opts: { method: 'get' | 'post'; [props: string]: any },
  useProxy: boolean = true,
): Promise<any> {
  if (!url || typeof url !== 'string') {
    throw new Error(`url is undefined`);
  }
  if (useProxy && envType !== 'prod') {
    const curDomainObj = projectJson.serviceTemplate?.[envType];
    const domain = curDomainObj?.domain || curDomainObj;
    return _ajaxProxy(requestAgent, domain && !url.startsWith('http') ? `${domain}${url}` : url, opts);
  }

  // 直连，不走代理
  return _ajax(requestAgent, url, opts);
}

function _ajax(requestAgent, url, opts?) {
  if (typeof url === 'object') {
    opts = url;
  } else {
    opts = Object.assign({ url: url, method: 'get' }, opts);
  }

  const params: any = getUrlParams();

  return new Promise((resolve, reject) => {
    requestAgent(opts)
      .then((resp) => {
        if (resp && resp.status === 200) {
          resolve(resp.data);
          // if (params.pageFromType !== 'main') {
          //   weblog?.fmp();
          //   console.log('fmp trigger after xhr');
          // }
        } else {
          reject(resp);
          // if (params.pageFromType !== 'main') {
          //   weblog?.fmp();
          //   console.log('fmp trigger after xhr'); 
          // }
        }
      })
      .catch((error) => {
        reject(error);
        // if (params.pageFromType !== 'main') {
        //   weblog?.fmp();
        //   console.log('fmp trigger after xhr');
        // }
      });
  });
}

function _ajaxProxy(requestAgent, url, opts?) {
  if (typeof url === 'object') {
    opts = url;
  } else {
    opts = Object.assign({ url: url, method: 'get' }, opts);
  }
  const { search, pathname, host, protocol } = new URL(opts.url);
  const options = { ...opts };
  options.headers = {
    ...options.headers,
    'x-target-host': `${protocol}//${host}`,
  };
  if (host.includes('.staging')) {
    options.headers['x-target-staging'] = true;
  }
  const laneId = projectJson.serviceTemplate?.[envType]?.laneId;
  if (laneId) {
    options.headers['x-target-laneId'] = `{"laneId":"${laneId}"}`;
  }
  const { cookie = '', Cookie = '', ...others } = options.headers;
  options.headers = {
    ...others,
  };
  if (cookie || Cookie) {
    options.headers['x-target-cookie'] = cookie || Cookie;
  }
  const { url: targetUrl, ...config } = options;

  return new Promise((resolve, reject) => {
    requestAgent({
      ...config,
      url: `/app/eca/desn/proxy${pathname}${search}`,
    })
      .then((resp) => {
        if (resp && resp.status === 200) {
          resolve(resp.data);
        } else {
          reject(resp);
        }
      })
      .catch((error) => {
        reject(error);
        console.log('error: ', error);
      });
  });
}

export const getRemoveNodeIdsByCrowd = async (crowdList) => {
  try {
    const data = await ajax(
      '/rest/h5/activity/traffic/c/delivery/resource/h5',
      {
        method: 'post',
        data: {
          pageCode: 'itemListPage',
          resource: [
            {
              resourceCode: 'dailyContrastCrowd',
              param: {
                crowds: crowdList.map((item) => item.crowdId).join(','),
              },
            },
          ],
        },
      },
      true,
    );
    if (data?.result !== 1 || !data?.data?.dailyContrastCrowd?.extInfo?.fullCrowds) {
      throw new Error('人群接口报错');
    }

    const fullCrowds = data.data.dailyContrastCrowd.extInfo.fullCrowds;

    const nodeIds = crowdList.filter((item) => fullCrowds.indexOf(item.crowdId) === -1).map((item) => item.nodeId);

    return nodeIds;
  } catch (e) {
    const nodeIds = crowdList.map((item) => item.nodeId);
    return nodeIds;
  }
};
